<template>
    <c-text-field v-if="readonly" :readonly="true" :value="readValue" :background-color="backgroundColorAdjusted" :label="label"></c-text-field>
    <v-autocomplete v-else :value="value" @change="onInput" outlined dense hide-details="auto" :items="items" :background-color="backgroundColorAdjusted" :label="label" :clearable="clearable"></v-autocomplete>
</template>

<script>
export default {
    props: {
        value: [String, Number],
        readonly: Boolean,
        items: Array,
        label: String,
        backgroundColor: String,
        clearable: Boolean
    },

    methods: {
        onInput (event) {
            // console.log(event);
            this.$emit('input', event)
        }
    },
    computed: {
        readValue () {
            if (this.items && this.items.length > 0 && !!this.items[0].value) {
                var selectedItem = this.items.find(i => i.value === this.value);
                return selectedItem ? selectedItem.text : this.value;
            }
            else {
                return this.value;
            }
        },
        backgroundColorAdjusted () {
            if (this.backgroundColor){
                return this.backgroundColor;
            }
            else if (this.readonly){
                return 'grey lighten-4';
            }
            else {
                return null;
            }
            // return this.backgroundColor ?? this.readonly ? 'grey lighten-4' : null;
        }
    }
}
</script>